import { filterByItemKey } from "../lib/filters";
import { useEntityById } from "../lib/hooks";
import BookList from "./bookList";
import * as api from "../lib/api";

const BooksBySeries = ({ seriesId, items }) => {
  const enrichSeries = (series) => {
    const seriesBooks = filterByItemKey("series", seriesId, items);
    return { ...series, items: [...api.sortBySeriesOrder(seriesBooks)] };
  };

  const series = useEntityById(seriesId, api.getSeriesById, enrichSeries, [
    items,
  ]);

  if (!series) return null;

  return (
    <div className="section">
      <div className="subheading" id={seriesId}>
        <h5>
          <a href={`/series/${series.route}`}>{series.title}</a>
        </h5>
      </div>
      <div className="content">
        <BookList items={series.items} />
      </div>
    </div>
  );
};

export default BooksBySeries;
